export default "__VITE_ASSET__adb0f675__"